import { render, staticRenderFns } from "./modalnputDetail.vue?vue&type=template&id=7936dc2a&scoped=true"
import script from "./modalnputDetail.vue?vue&type=script&lang=js"
export * from "./modalnputDetail.vue?vue&type=script&lang=js"
import style1 from "./modalnputDetail.vue?vue&type=style&index=1&id=7936dc2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936dc2a",
  null
  
)

export default component.exports